import { gql } from '@apollo/client';
import { coupledLineItemsOnInvoice, lineItemDetailsForInvoice } from './fetch-coupled-line-items';

export const fetchInvoiceQueryV2 = gql`
  ${lineItemDetailsForInvoice}
  ${coupledLineItemsOnInvoice}
  query fetchInvoiceQueryV2(
    $id: ID!
    $transactionAccountId: String
    $fetchAddOns: Boolean = false
    $fetchAGPAddon: Boolean = false
  ) {
    invoice(
      id: $id
      transactionAccountId: $transactionAccountId
      fetchAddOns: $fetchAddOns
      fetchAGPAddon: $fetchAGPAddon
    ) {
      id
      invoiceNumber
      sourceId
      selfServeBACInvoiceLink
      invoiceNumber
      domain
      status
      createdTimestamp
      userDefinedNotes
      billingGroupId
      paymentMethodId
      creditCard {
        last4Numbers
        cardHolderName
        expirationMonth
        expirationYear
        brand
      }
      dunningStatus {
        attemptCount
        paymentRetryDate
        errorCode
        declineCode
        nextPaymentAttempDate
      }
      sourceSystem
      upgradeCredits
      totalDiscount
      totalPartnerMargin
      memo
      billTo {
        fullName
        organization
        email
        address {
          address1
          address2
          city
          country
          phone
          postalCode
          state
        }
        taxId
        taxIds {
          id
          label
          taxExempt
          metadata {
            vatStatus
          }
        }
        taxLabels {
          region
          taxIdLabels {
            description
            displayName
            type
          }
        }
      }
      shipTo {
        id
        fullName
        organization
        email
        address {
          address1
          address2
          city
          country
          phone
          postalCode
          state
        }
        taxId
        taxIds {
          id
          label
          taxExempt
          metadata {
            vatStatus
          }
        }
        taxLabels {
          region
          taxIdLabels {
            description
            displayName
            type
          }
        }
      }
      total
      taxes
      subtotal
      taxes
      taxesPaymentCurrency
      transactionAccountId
      itemsTotal
      partnerAccountId
      partnerName
      paypalAccountEmail
      paymentCurrency
      paymentMethod
      promotionCode
      invoiceDueDays
      dueDate
      purchaseOrderNumber
      lineItems {
        ...lineItemDetailsForInvoice
        orderLineId
      }
      coupledLineItems(fetchAGPAddon: $fetchAGPAddon) {
        ...coupledLineItemsOnInvoice
      }
      dstLineItems {
        ...lineItemDetailsForInvoice
        metadata {
          parentItemId
          type
        }
      }
      refunds {
        id
        creditNoteNumber
        currency
        createdDate
        transactionAccountId
        sourceSystem
        memo
        reason
        refundId
        status
        type
        total
        arn
        refundItems {
          id
          invoiceLineItemId
          entitlementId
          quantity
          description
          total
          totalExTax
          totalTax
          taxRate
          taxableAmount
          taxExemptAmount
        }
        requestedBy
      }
      slaCredits {
        amountExTax
        amountIncTax
        createdAt
        creditExternalId
        currency
        currencyExchangeRate
        modifiedAt
        notes
        taxAmount
        taxRate
      }
      pdfLink
      appliedBalance
    }
  }
`;
